// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";
import * as Outline from "@heroicons/react/outline";
import PhotoToOilPaintingPng from "../global/images/photo-to-oil-painting.png";
import PhotoToOilPainting2xPng from "../global/images/photo-to-oil-painting@2x.png";

import { css, cx } from '@linaria/core'
;

var logo = PhotoToOilPaintingPng;

var logo2x = PhotoToOilPainting2xPng;

var style = (css`
    .banner {
      @apply -mt-3;
    }
    `);

var Root = {
  style: style
};

var style$1 = (css`
      @apply border-b-black border-b top-0 pt-2 pb-2 pl-3 pr-3 z-10 mb-0;
      border-bottom: 1px solid rgba(127, 127, 127, 0.3);
    `);

var OuterContainer = {
  style: style$1
};

var style$2 = (css`
      @apply grid grid-rows-1 content-end ml-auto;
      a {
        font-family: futura-pt, Helvetica, sans-serif;
        @apply pt-1 pb-1;
        -webkit-font-smoothing: antialiased;
      }
      a.dropdown:after {
        display: block;
        width: 0;
        height: 0;
        border: 6px inset;
        content: '';
        border-bottom-width: 0;
        border-top-style: solid;
        border-color: #8d6ba6 transparent transparent;
        right: 5px;
        left: auto;
        margin-top: -3px;

        position: absolute;
        @apply top-3 md:top-1/2;
      }
      a.cart {
        color: #c182f8;
      }
    `);

var Nav = {
  style: style$2
};

var style$3 = (css`
    @apply container flex flex-wrap justify-between items-center mx-auto px-4 sm:px-6 lg:px-8;
    `);

var Container = {
  style: style$3
};

var styleClosed = (css`
    @apply hidden justify-between items-center w-full md:flex md:w-auto md:order-1 ml-auto;
    > ul {
      @apply list-none md:flex md:flex-row;

      li {
        a {
          @apply md:pl-6 pr-6;
        }
        a:last-child {
          @apply pr-0;
        }
        color: #8d6ba6;
        position: relative;
      }
      > li:hover {
          div.dropdown {
            @apply md:block;
          }
      }
    }
    `);

var mobileOpen = (css`
  display: block;
    `);

var style$4 = (cx(styleClosed, mobileOpen));

var ExpandedContainer = {
  styleClosed: styleClosed,
  mobileOpen: mobileOpen,
  style: style$4
};

var style$5 = (css`
    @apply flex items-center md:order-2;
    `);

var MiniContainer = {
  style: style$5
};

var style$6 = (css`
    @apply ml-0;
    span {
      font-family: Georgia, serif;
      color: black;
      display: inline;
      line-height: 13px;
      vertical-align: text-bottom;
      font-size: 1.2em;
      font-weight: normal;
      letter-spacing: 3px;
      strong {
        font-family: helvetica;
        vertical-align: bottom;
      }
    }
  `);

var Logo = {
  style: style$6
};

var style$7 = (css`
    @apply mr-2 h-7 sm:h-7 sm:max-h-7 w-auto max-h-7;
    display: inline;
    `);

var Img = {
  style: style$7
};

var style$8 = (css`
    @apply self-center text-xl font-semibold whitespace-nowrap dark:text-white;
    `);

var LogoText = {
  style: style$8
};

var base = (css`
    @apply md:origin-top-right md:absolute md:right-0 md:w-56 md:rounded-md md:shadow-lg md:bg-white md:ring-1 md:ring-black md:ring-opacity-5 md:divide-y md:divide-gray-100 divide-gray-100 divide-y md:focus:outline-none md:pl-0 z-10;
    @apply md:hidden md:-mt-0;
    ul {
      @apply py-1;
      li a {
        @apply text-gray-700 block px-4 sm:px-5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900;
      }

    }
    `);

var styleOpen = Core.cx("dropdown", base, "block");

var styleClosed$1 = (cx('dropdown', base, 'hidden'));

var DropdownMenu = {
  base: base,
  styleOpen: styleOpen,
  styleClosed: styleClosed$1
};

var MenuIcon = {};

var XIcon = {};

var style$9 = (css`
        @apply inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600;
        span {
          @apply sr-only;
        }
        svg {
          @apply w-6 h-6;
        }
        ul {
          @apply flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium;

        }
      `);

function Nav$ExpandMenuBtn(props) {
  var __open_ = props.open_;
  var open_ = __open_ !== undefined ? __open_ : false;
  return JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx("span", {
                      children: "Open main menu"
                    }),
                open_ ? JsxRuntime.jsx(Outline.XIcon, {
                        "aria-hidden": "true"
                      }) : JsxRuntime.jsx(Outline.MenuIcon, {
                        "aria-hidden": "true"
                      })
              ],
              "aria-expanded": false,
              "aria-controls": "mobile-menu",
              className: style$9,
              type: "button",
              onClick: props.onClick
            });
}

var ExpandMenuBtn = {
  MenuIcon: MenuIcon,
  XIcon: XIcon,
  style: style$9,
  make: Nav$ExpandMenuBtn
};

var style$10 = (cx(css`
        @apply relative bg-primary-900;
        &> div {
          @apply max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8;
          &> div {
            @apply pr-16 sm:text-center sm:px-16;
            p {
              @apply font-medium text-white;
              span.short {
                @apply md:hidden;
              }
              span.long {
                @apply hidden md:inline;
              }
              span.cta {
                @apply block sm:ml-2 sm:inline-block;
                a {
                  @apply text-white font-bold underline;
                }
              }
            }
          }
        }
      `, 'banner'));

function Nav$SlimBanner(props) {
  var link = props.link;
  var shortMessage = props.shortMessage;
  var message = props.message;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("p", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: shortMessage !== undefined ? shortMessage : message,
                                        className: "short"
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: message,
                                        className: "long"
                                      }),
                                  link !== undefined ? JsxRuntime.jsx("span", {
                                          children: JsxRuntime.jsx("a", {
                                                children: "Learn more",
                                                href: link
                                              }),
                                          className: "cta"
                                        }) : null
                                ]
                              })
                        })
                  }),
              className: style$10
            });
}

var SlimBanner = {
  style: style$10,
  make: Nav$SlimBanner
};

var style$11 = (css`
        @apply container mx-auto px-4 sm:px-6 lg:px-8;
      `);

function Nav$LayoutContainer(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: style$11
            });
}

var LayoutContainer = {
  style: style$11,
  make: Nav$LayoutContainer
};

function toReact(param) {
  var title = param.title;
  return JsxRuntime.jsx("li", {
              children: JsxRuntime.jsx("a", {
                    children: title,
                    role: "menuitem",
                    href: param.link
                  }),
              role: "none"
            }, title);
}

var MenuItem = {
  toReact: toReact
};

var MenuItemEl = {
  fromDomain: toReact
};

function toReact$1(items) {
  return JsxRuntime.jsx("ul", {
              children: Belt_Array.map(items, toReact),
              className: "dropdown",
              role: "none"
            });
}

var MenuSection = {
  toReact: toReact$1
};

var MenuSectionEl = {
  fromDomain: toReact$1
};

var galleryProducts = [
  {
    title: "Oil Painting",
    link: "/gallery/featured/paintings"
  },
  {
    title: "Watercolor Painting",
    link: "/gallery/featured/watercolor"
  },
  {
    title: "Colored Pencil Drawing",
    link: "/gallery/featured/colored-pencil"
  },
  {
    title: "Charcoal Drawing",
    link: "/gallery/featured/charcoal"
  },
  {
    title: "Pencil Drawing",
    link: "/gallery/featured/pencil"
  },
  {
    title: "Digital Portrait",
    link: "/gallery/featured/digital-portrait-painting-canvas"
  }
];

var galleryFeaturedSubjects = [
  {
    title: "Portrait Paintings",
    link: "/portrait-paintings"
  },
  {
    title: "Pet Portraits",
    link: "/gallery/pet-portraits"
  },
  {
    title: "Wedding Paintings",
    link: "/gallery/wedding-paintings"
  },
  {
    title: "Baby and Kids Paintings",
    link: "/gallery/baby-paintings"
  },
  {
    title: "Landscape, Abstract, and Other",
    link: "/gallery/landscape-paintings"
  }
];

var gallerySubjects = [
  {
    title: "Artistic Style Paintings",
    link: "/gallery/style-paintings"
  },
  {
    title: "Replace Face/Royal Portraits",
    link: "/gallery/reface"
  },
  {
    title: "Change Background",
    link: "/gallery/replace-background"
  },
  {
    title: "Change or Adjust Something",
    link: "/gallery/change-things"
  },
  {
    title: "Add People or Things",
    link: "/gallery/add-things"
  },
  {
    title: "Remove People or Things",
    link: "/gallery/remove-things"
  },
  {
    title: "Merge Photos",
    link: "/gallery/merge-photos"
  },
  {
    title: "Classical Replicas",
    link: "/gallery/replica-painting"
  },
  {
    title: "Restore an Old Photo",
    link: "/gallery/restore-photo"
  }
];

var products = [
  {
    title: "Oil Painting",
    link: "/products/custphotoreal"
  },
  {
    title: "Watercolor Painting",
    link: "/products/custwatercolor"
  },
  {
    title: "Colored Pencil Drawing",
    link: "/products/custcoloredpencil"
  },
  {
    title: "Charcoal Drawing",
    link: "/products/custcharcoal"
  },
  {
    title: "Pencil Drawing",
    link: "/products/custpencil"
  }
];

function Nav$1(props) {
  var logoSize = {
    width: 45,
    height: 50
  };
  var match = React.useState(function () {
        return false;
      });
  var setMobile = match[1];
  var mobile = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setGalleryOpen = match$1[1];
  var match$2 = React.useState(function () {
        return false;
      });
  var setProductsOpen = match$2[1];
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("header", {
                    children: JsxRuntime.jsx("nav", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("a", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: style$7,
                                                alt: "Instapainting Logo",
                                                height: String(logoSize.height),
                                                src: logo,
                                                srcSet: logo2x + " 2x",
                                                width: String(logoSize.width)
                                              }),
                                          JsxRuntime.jsx("span", {
                                                children: "INSTAPAINTING"
                                              })
                                        ],
                                        className: style$6,
                                        href: "/"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsxs("ul", {
                                                      children: [
                                                        JsxRuntime.jsx("li", {
                                                              children: JsxRuntime.jsx("a", {
                                                                    children: "GALLERY",
                                                                    href: "/carts/checkout"
                                                                  })
                                                            }),
                                                        JsxRuntime.jsx("li", {
                                                              children: JsxRuntime.jsx("a", {
                                                                    children: "HELP",
                                                                    href: "/carts/checkout"
                                                                  })
                                                            }),
                                                        JsxRuntime.jsx("li", {
                                                              children: JsxRuntime.jsxs("a", {
                                                                    children: [
                                                                      JsxRuntime.jsx("i", {
                                                                            className: "fi-shopping-cart"
                                                                          }),
                                                                      " CART"
                                                                    ],
                                                                    className: "cart",
                                                                    href: "/carts/checkout"
                                                                  })
                                                            })
                                                      ],
                                                      "aria-labelledby": "dropdown"
                                                    }),
                                                className: styleClosed$1
                                              }),
                                          JsxRuntime.jsx(Nav$ExpandMenuBtn, {
                                                onClick: (function (e) {
                                                    e.preventDefault();
                                                    setMobile(function (prev) {
                                                          return !prev;
                                                        });
                                                  }),
                                                open_: mobile
                                              })
                                        ],
                                        className: style$5
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("ul", {
                                              children: [
                                                JsxRuntime.jsxs("li", {
                                                      children: [
                                                        JsxRuntime.jsx("a", {
                                                              children: "GALLERY",
                                                              className: "dropdown",
                                                              id: "gallery-dropdown",
                                                              href: "#",
                                                              onClick: (function (e) {
                                                                  e.preventDefault();
                                                                  setGalleryOpen(function (prev) {
                                                                        return !prev;
                                                                      });
                                                                })
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                toReact$1(galleryProducts),
                                                                toReact$1(galleryFeaturedSubjects),
                                                                toReact$1(gallerySubjects)
                                                              ],
                                                              "aria-labelledby": "gallery-dropdown",
                                                              className: match$1[0] ? styleOpen : styleClosed$1,
                                                              role: "menu"
                                                            })
                                                      ],
                                                      className: "menu-item",
                                                      role: "none"
                                                    }),
                                                JsxRuntime.jsxs("li", {
                                                      children: [
                                                        JsxRuntime.jsx("a", {
                                                              children: "PRODUCTS & PRICING",
                                                              className: "dropdown",
                                                              id: "products-dropdown",
                                                              href: "#",
                                                              onClick: (function (e) {
                                                                  e.preventDefault();
                                                                  setProductsOpen(function (prev) {
                                                                        return !prev;
                                                                      });
                                                                })
                                                            }),
                                                        JsxRuntime.jsx("div", {
                                                              children: toReact$1(products),
                                                              "aria-labelledby": "products-dropdown",
                                                              className: match$2[0] ? styleOpen : styleClosed$1,
                                                              role: "menu"
                                                            })
                                                      ],
                                                      role: "none"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("a", {
                                                            children: "HELP",
                                                            href: "/support"
                                                          }),
                                                      role: "none"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsxs("a", {
                                                            children: [
                                                              JsxRuntime.jsx("i", {
                                                                    className: "fi-shopping-cart"
                                                                  }),
                                                              " CART"
                                                            ],
                                                            className: "cart",
                                                            href: "/carts/checkout"
                                                          }),
                                                      role: "none"
                                                    })
                                              ],
                                              role: "menubar"
                                            }),
                                        className: mobile ? style$4 : styleClosed,
                                        id: "mobile-menu"
                                      })
                                ],
                                className: style$3
                              }),
                          className: style$2
                        }),
                    className: style$1
                  }),
              className: style
            });
}

var make = Nav$1;

var $$default = Nav$1;

export {
  logo ,
  logo2x ,
  Root ,
  OuterContainer ,
  Nav ,
  Container ,
  ExpandedContainer ,
  MiniContainer ,
  Logo ,
  Img ,
  LogoText ,
  DropdownMenu ,
  ExpandMenuBtn ,
  SlimBanner ,
  LayoutContainer ,
  MenuItem ,
  MenuItemEl ,
  MenuSection ,
  MenuSectionEl ,
  galleryProducts ,
  galleryFeaturedSubjects ,
  gallerySubjects ,
  products ,
  make ,
  $$default as default,
}
/*  Not a pure module */
